import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	Grid, Table, TableHeaderRow, TableRowDetail,
} from '@devexpress/dx-react-grid-bootstrap3';
import { isEqual, get } from 'lodash';
import { Loader } from '@components/common';
import { RowDetailStateContainer, SortingStateContainer } from './containers';
import {
	DetailsRowComponent, CellComponent, RowComponent, TableHeaderComponent,
} from './components';

class JobsTable extends Component {
	constructor(props) {
		super(props);

		this.columns = [
			{ name : 'job', title : 'Job', getCellValue : (row) => get(row, 'Id', '') },
			{ name : 'location', title : 'Location', getCellValue : (row) => get(row, 'LocationName', '') },
			{ name : 'status', title : 'Officer + Status', getCellValue : (row) => get(row, 'AgencyName', '') },
			{ name : 'date', title : 'Start Date + Time', getCellValue : (row) => get(row, 'StartDateTime', '') },
			{ name : 'actions', title : ' ' },
		];

		this.tableColumnExtensions = [
			{ columnName : 'job', width : 330 },
			{ columnName : 'location', width : 240 },
			{ columnName : 'status', width : 220 },
			{ columnName : 'date', width : 170 },
		];

		this.sortingStateColumnExtensions = [
			{ columnName : 'status', sortingEnabled : false },
			{ columnName : 'actions', sortingEnabled : false },
		];
	}

	shouldComponentUpdate({ rows, loading }) {
		const lastProps = this.props;

		return (
			!isEqual(rows, lastProps.rows)
			|| !isEqual(loading, lastProps.loading)
		);
	}

	render() {
		const { rows, loading } = this.props;

		return (
			<div className="position-relative">
				<Grid
					rows={rows}
					columns={this.columns}
					className="table-v2"
				>
					<RowDetailStateContainer />
					<SortingStateContainer
						columnExtensions={this.sortingStateColumnExtensions}
					/>
					<Table
						cellComponent={CellComponent}
						rowComponent={RowComponent}
						columnExtensions={this.tableColumnExtensions}
					/>
					<TableHeaderRow
						showSortingControls
						contentComponent={TableHeaderComponent}
					/>
					<TableRowDetail
						contentComponent={DetailsRowComponent}
						toggleCellComponent={CellComponent}
					/>
				</Grid>
				<Loader
					active={loading}
					className="padding-top-30"
				/>
			</div>
		);
	}
}

JobsTable.propTypes = {
	rows    : PropTypes.array,
	loading : PropTypes.bool,
};

JobsTable.defaultProps = {
	rows    : [],
	loading : false,
};

export default JobsTable;
